import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Roles} from '../../pages/settings/roles/roles.model';


export interface UsersRequestParam {
    id: number;
    name: string;
}

@Injectable()
export class UsersService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // fetch Roles
    getUsers(pageNumber: any, noOfRecords: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', noOfRecords);
        return this.apiRequest.get(this.appConfig.user_url, params);
    }


    // assign role

    assignRole(id: number, role: number[]): Observable<any> {
        return this.apiRequest.post(this.appConfig.user_url + '/' + id + '/assign-roles', role);
    }

    // fetch users
    fetchUsersForRole(id: number): Observable<any> {
        return this.apiRequest.get(this.appConfig.user_url + '/' + id + '/roles');
    }

}
